/*
 * @Author: hfxie
 * @Date: 2022-08-17 17:23:53
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-09-06 14:55:34
 * @Description: file content
 */
import OutConst from "../customEventOutConst.js";
const action = {
  [OutConst.CUSTOM_INIT](store, obj) {
    this._invoke(OutConst.CUSTOM_INIT, obj);
  },
  [OutConst.GET_FILTER](store, str) {
    if (this.state.local.filterStr != str) {
      this.commit("set_local_filterStr", str);
    }
    this._invoke(OutConst.GET_FILTER, str);
  },
  [OutConst.UPDATE_FILTERSTATUS](store, status) {
    this.commit("set_filterStatus", status);
    // this._invoke(OutConst.UPDATE_FILTERSTATUS, status); // 服务端不记录
  },
  [OutConst.OPEN_SEARCH](store, str) {
    if (this.state.local.filterStr != str) {
      this.commit("set_local_filterStr", str);
    }
    this._invoke(OutConst.OPEN_SEARCH, str);
  },
  [OutConst.OPT_ADD](store, obj) {
    this._invoke(OutConst.OPT_ADD, obj);
  },
};

export default action;
